export default __webpack_public_path__ + "static/media/international.d572fe25.png";